
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import axios from 'axios';
import Signup from './Signup';
import Configdata from './Defaultdata';

import {isvalidatemail,isvalidmob,isvaluenull,isvaliduser} from './validation';
import { getmessage,wrongmsg,getusertype,searchpostnow,clearform,gtlclstor } from './Dynamictable';
import { cityidfromcod,loadwidgate,sets,getloginuser,setlogininfo,showdelay,closedelay } from './userdefaultdata';
import Usersession from './Usersession';
import Forgotpassword from './Forgotpassword'
import {unmountComponentAtNode} from 'react-dom';
import Home from './Home';
import {showmesage} from './message';
class Register extends Component {
	constructor(props: any) {
   	super(props);
	this.state.togglesineup = false;
    	this.state.ltypeguest = false;

  	}
	state = {
        name: "",
	email:"",
	remail:"",
	paswrd:"",
	mlorph:"",
        togglecrit: false,
        togglesineup:false,
	slcttype:false,
	ltypeguest:false
	
	
    	};

	guestlogindivshow(){
		this.setState({ ltypeguest: true });
		this.displayenrtryname(1);
		this.displayenrtryemail(1);
		this.displayenrtrypass(0);

	}
        logindivshow(){

         	 this.setState({ slcttype: true });
		this.setState({ ltypeguest: false });
		this.displayenrtryname(0);
		this.displayenrtryemail(1);
		this.displayenrtrypass(1);
		
	}
	typeselect(e: any){
		
		this.desecttypes();
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';

		//alert(eid);
		if(eid == 'loginguestdiv')
		{
		 this.guestlogindivshow();
		
		}
		else if(eid == 'loginuserdiv'){
		this.logindivshow();
		//this.setState({ slcttype: true });
		//this.setState({ ltypeguest: false });
		//this.displayenrtryname(0);
		//this.displayenrtryemail(1);
		//this.displayenrtrypass(1);
		
		}
		else if(eid == 'searchlease'){
		this.setState({ slcttype: true });
		
		}
		else if(eid == 'searchservice'){
		this.setState({ slcttype: true });
		}

		e.preventDefault()

	};
	usersineup(e: any){
	   try {
		
	     Usersession.setCode("NA");
            
             loadwidgate('container',15);
               
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};
	forgotpswd(e: any){
	   try {
		
		const forgotpswd = <Forgotpassword />
             
                var maindiv = document.getElementById('sinupsidebardiv') as HTMLElement;
		const Pdivr = document.getElementById('recoverydiv') as HTMLElement;
		//ReactDOM.render(forgotpswd,Pdivr);
		maindiv.style.display = 'none';
		Pdivr.style.display = 'block';
	     
	   }
	    catch(e){
		
	     }	
	     e.preventDefault()

	};

	iregctrlsvalidate(tp: any){
	 let isvalid = true;
        
	 let mailorphone = false;	
		if(!isvalidatemail(this.state.email)){
		 getmessage('Invalid mail Id','');

			 isvalid = false;
			
		}
		if(isvaluenull(this.state.paswrd)){
		 getmessage('password should not blank','');
	  	return false;
		
		}	
	return isvalid;
	}
 ctrlvalidmail(tp: any){
	 let isvalid = true;
	       
		if(!isvalidatemail(this.state.remail)){
		       getmessage('Invalid mailId','');
			 isvalid = false;
			
		}
		 
	return isvalid;
	}
	

	desecttypes(){
		this.setState({ slcttype: false });
		const gstuser = document.getElementById('loginguestdiv') as HTMLElement;
		const logonuser = document.getElementById('loginuserdiv') as HTMLElement;
		gstuser.style.backgroundColor = 'gray';
		logonuser.style.backgroundColor = 'gray';

		
	}
	displayenrtryname(d: any){
	const unamedv = document.getElementById('unamediv') as HTMLElement;

	 if(d == 0) unamedv.style.display = 'none';
	 else 	unamedv.style.display = 'block';

	}
	displayenrtryemail(d: any){
	const umail = document.getElementById('uemailodiv') as HTMLElement;

	 if(d == 0) umail.style.display = 'none';
	 else 	umail.style.display = 'block';

	}
	displayenrtrypass(d: any){
	const upass = document.getElementById('upassdiv') as HTMLElement;

	 if(d == 0) upass.style.display = 'none';
	 else 	upass.style.display = 'block';

	}


	componentDidMount() {
        //debugger;
	
     	 //this.guestlogindivshow();
	this.logindivshow();
     
    	}

	textboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	//alert(id);
        if(id == 'txtusername'){
        
	 this.setState({ name: elvalue });
	}
	else if(id == 'txtusermail'){
	
	 this.setState({ email: elvalue });
	}
        else if(id == 'txtrcvusermail'){
	
	 this.setState({ remail: elvalue });
	}
	
	else if(id == 'txtpassword'){
	
	 this.setState({ paswrd: elvalue });
	
	}
	
   }

setuserlogin(e:any){
  this.loginauthouser();
  		
  e.preventDefault()
}
insertuserrcv(e:any){
this.insertuserrecuvery();
  		
  e.preventDefault();

}
setlogintouser(){
 	
	this.loginauthouser();
	//localStorage.setItem("ltype",'authorized');
}
setuserauthority(usrcode:any,usrtype: any,usrpoints:any,usroffer: any){
        
        const username = this.state.name;
        const usermail = this.state.email;
	const userinfo ={id:"NA",uname:username,utype: usrtype,upoints: usrpoints,offer:     	usroffer,ltype:'unauthorized',phone:"",mailid:usermail,mailvrfy:'0',phonevrify:'0'};
        const struserinfo = JSON.stringify(userinfo);
	localStorage.setItem("userinfo",struserinfo);
	localStorage.setItem("id","NA");
       
}


insertuserrecuvery(){
	 try {
                let url = Configdata.srvurl + '/insetpassrcv';
		if(this.ctrlvalidmail('na')){
          	
		const mailid = this.state.remail;
		
                const response = axios.post(url, {
    		
    		uemail: mailid
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
		 
		setlogininfo(usercd);
		
		
	        });		
              }
		
	   }
          }
        catch (exp:any) {
           // debugger;
		wrongmsg();
            closedelay();
        }
}
loginauthouser(){
	 try {
	        let url = '';
               //alert('1');
		const mailid = this.state.email;
	        
 		const userpaswrd = this.state.paswrd.trim();
	
		if(this.iregctrlsvalidate('autho')){
                 showdelay();
		const usermail = this.state.email.trim();
          	
		const apiurl = Configdata.srvurl + '/loginusertrasc';
              // alert(apiurl);
                const response = axios.post(apiurl, {
    		pass: userpaswrd,
    		mlph: 'mail',
    		uemail: usermail
              
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
               
		if(usercd == 'NA'){
                closedelay();
                getmessage('Wrong mail id or password','');
	        }
		else{
                //const usersdata = usercd;
		const udata = usercd.sdata;
		const users = usercd.sbusers;
                   
                this.configusers(udata,users);
 
              // getloginuser(usercd);	
		
		}
		
		
	        });		
              }
               

	     }	
         
	   }
         
        catch (ex:any) {
           // debugger;
                closedelay();

		wrongmsg();
        }
}
configusers(userdata:any,subusersdata:any){
               var upin ='0';
		const suserid = userdata.split('-')[1];	
		const usernm = userdata.split('-')[0];	
		if(userdata.split('-').length > 2) upin = userdata.split('-')[2];
                sets(suserid,upin,usernm,"NA");
		setlogininfo(subusersdata);
                
		 closedelay();

}
gotosearchprpty(e:any){
        let criterias = Usersession.getSearchopts();
       
	//Usersession.setSearchopts(criterias);
	const homemain = document.getElementById('container') as HTMLElement;
      
	homemain.style.display = 'block';
	const Pdivc = document.getElementById('profilediv') as HTMLElement;
	if(Pdivc)
	Pdivc.style.display = 'none';
	if(homemain){
	unmountComponentAtNode(homemain);
	const srch = <Home />;
	ReactDOM.render(srch,homemain);	
	}
   }
	
getdatasearch(){

this.gotosearchprpty(0);
 }	
     closeprofilediv(){
	const Pdivr = document.getElementById('profilediv') as HTMLElement;
	Pdivr.style.display ='none';
     }

	render() {
		return (
		<form id="frmlogin">
		<div>	
                <div id="sinupsidebardiv" className="sidebar-search" style={{width:'80vw',left:'5vw',top:'30vh'}}>

		     <div className="search-title-bar">
                       	<div className="search-title">
			  SignIn
			</div>
			
	   	     </div>
		  <div id="selectlogintype" className="sidebar-scroll">
		   	
		     <div className="sidebar-basic-info" style={{width:'100%',display:'none'}}>
		       <div> 
			<a href="#" id="guestlogintype" onClick={e => this.typeselect(e)} title="Guest">

                       	<div className="searchtype" id="loginguestdiv" >
			  Guest	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="authorized">

			<div className="searchtype" id="loginuserdiv" style={{backgroundColor:'green'}}>
			  Authoriz	
			</div>
			</a>
		     </div>
		    </div>
		   <div className="sidebar-basic-info" id="unamediv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginusername" style={{width:'94%'}}>
			  <input placeholder="Enter Name"  onChange={e => this.textboxChange(e)} id="txtusername" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>

		   <div className="sidebar-basic-info" id="uemailodiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="loginuseremail" style={{width:'94%'}}>
			  <input placeholder="Enter email"  onChange={e => this.textboxChange(e)} id="txtusermail" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
		     <div className="sidebar-basic-info" id="upassdiv" style={{width:'90%',marginTop:'3vh'}}>
		       <div>	
			 <div className="searchtype" id="userpassworddiv" style={{width:'94%'}}>
			  <input placeholder="Enter password"  onChange={e => this.textboxChange(e)} id="txtpassword" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
		    </div>
	
		   
		   	
		     <div className="sidebar-basic-info" style={{width:'100%' ,marginTop:'5vh',height:'60px'}}>
		       <div> 
			

                       	<div id="signupdiv" style={{width:'55%',float:'left',padding:'10px'}}>
<a href="#" className="blanka" onClick={e => this.forgotpswd(e)} title="forgot password">forgot password</a> &nbsp;&nbsp;&nbsp;
			<a href="#" className="blanka" onClick={e => this.usersineup(e)} title="SignUp">SignUp</a> &nbsp;
			
			

			</div>
			
			<a href="#" onClick={e => this.setuserlogin(e)} title="Login">

			<div className="searchtype" id="usersignin" style={{width:'28%',float:'left'}}>
			  LogIn	
			</div>
			</a>
		     </div>
		    </div>

 		   


		 </div>
	      </div>
		 <div id="recoverydiv" className="sidebar-search" style={{width:'80vw',left:'5vw',top:'15vh',display:'none'}}>

		     <div className="search-title-bar">
                       	<div className="search-title">
			  Recovery password
			</div>
		     </div>
		    <div className="sidebar-basic-info" id="recuemailodiv" style={{width:'90%',marginTop:'5vh'}}>
		       <div>	
			 <div className="searchtype" id="rcvuseremail" style={{width:'94%'}}>
			  <input placeholder="Enter email"  onChange={e => this.textboxChange(e)} id="txtrcvusermail" type="text" style={{width:'90%'}}/>
	
			 </div>
 
		       </div>
         
		    </div>
		     <div>	
			<a href="#" onClick={e => this.insertuserrcv(e)} title="Send">

			<div className="searchtype" id="rcvusersignin" style={{width:'28%',float:'right',marginRight:'12%'}}>
			  Send	
			</div>
			</a>
	               </div>

		</div>
		
	     </div>
		

		</form>
		);
	}

	
}

export default Register;
